import React from 'react'
import { MainArticleLayout } from '../layouts/MainArticleLayout'

const PageNotFound = () => {
  return (
    <MainArticleLayout>
      <h1>Page not found</h1>
      <p>
        The page you are looking for does not exists. Please check the URL in
        the browser address bar.
      </p>
    </MainArticleLayout>
  )
}

export default PageNotFound
